import React from 'react';
import { Modal } from 'antd';
import * as Actions from '../../../actions/operatingStatistics';
import './hotStory.scss';

class HotStory extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            limit: '7',
            title:'',
            list:[],
            visible: false,
            urlInfo: {}

        }
    }

    componentDidMount(){
        const { resourceType } = this.props;
        let title = ''
        if(resourceType === '1'){
            title = '网站热文排行'
        }
        if(resourceType === '2'){
            title = '微信热文排行'
        }
        if(resourceType === '3'){
            title = '微博热文排行'
        }
        this.setState({
            title
        })
        this.getList();
    }

    getList = () => {
        let params = { mediaType: this.props.resourceType,dayLimit: this.state.limit}
        Actions.findHotStorysByMeidaType(params, (res) => {
            this.setState({
                list: res.data
            })
        })
    }

    changeLimit = (limit) => {
        this.setState({
            limit
        }, () =>{
            this.getList();
        })
    }

    changeModalVisible = (item) => {
        let urlInfo = item.url && JSON.parse(item.url)
        this.setState({
            urlInfo,
            visible: true
        })
    }

    

    render() {
        const { title, limit, list, visible, urlInfo } = this.state;
        console.log(urlInfo)
        return (
            <>
                <div className="hot-story">
                    <div className="hot-story-title">
                        <div className="left">
                            <span>{title}</span>
                        </div>
                        <div className="right">
                            <span className={`${limit === '30' ? 'active' : ''}`} onClick={() => this.changeLimit('30')}>近30天</span>
                            <span className={`${limit === '7' ? 'active' : ''}`} onClick={() => this.changeLimit('7')}>近7天</span>
                        </div>
                    </div>
                    <div className="hot-story-content">
                        <div className="first">
                            <span>标题</span>
                            <span>阅读量</span>
                        </div>
                        {
                            list && list.length > 0 &&
                            list.map((item, index) => (
                                <div className="item" key={index} onClick={() => this.changeModalVisible(item)}>
                                    <span>{index + 1}</span>
                                    <span>{item.title}</span>
                                    <span>{item.pv}</span>
                                </div>
                            ))
                        }
                    </div>
                </div>
                <Modal
                    visible={visible}
                    width={700}
                    title="发布地址列表"
                    onCancel={()=> this.setState({ visible: false })}
                    footer={null}
                    className="url-info-modal"
                >
                    <div className="url-info-content">
                    {
                        urlInfo && urlInfo.length > 0 && urlInfo.map((item, index) => (
                            <div key={index}>
                                <span>{item.column && item.column}</span>
                                <span>
                                    {
                                        typeof (item.url) === 'string' ? <a href={item.url && item.url} target="_blank" rel="noopener noreferrer" title={item.url && item.url} >{item.url && item.url}</a> : ''
                                    }
                                </span>
                            </div>
                        ))
                    }
                    </div>
                </Modal>
            </>
        )
    }
}

export default HotStory